import React, {Component} from 'react';
import {ButtonIcon} from '@homeaway/react-buttons';
import {SVGIcon} from '@homeaway/react-svg';
import {HEART_SELECTED__16} from '@homeaway/svg-defs/lib/defs/HEART_SELECTED__16';

import AddToTripBoard from '../AddToTripBoard/AddToTripBoard';
import AddToTripBoardNewModal from '../AddToTripBoard/AddToTripBoardNewModal';
import CreateTripBoard from '../CreateTripBoard/CreateTripBoard';
import CreateTripBoardNewModal from '../CreateTripBoard/CreateTripBoardNewModal';
import {ADD_TO_BOARD, CREATE_BOARD} from '../../constants';
import edap from '../../utils/edap';
import TripBoardNewModal from './TripBoardNewModal';
import Modal from '@homeaway/react-modal';
import {MAX_TRIPBOARD_NAME_LENGTH} from '../../constants';
import AbacusClientUtils from '@homeaway/abacus-client-utils';
import {NEW_MODAL} from '../../constants';

import './TripBoardModal.less';

class TripBoardModalContainer extends Component {
    static defaultProps = {
        className: 'react-trip-board-button__modal',
        id: 'react-trip-board-button-modal'
    };

    constructor(props) {
        super(props);

        this.state = {
            isEditing: true,
            isOpen: false,
            caret: null,
            listingId: null,
            position: null,
            currentView: CREATE_BOARD,
            newBoardName: '',
            isNewModalTestOn: false,
            heartPosition: null,
            tripBoards: [],
            translations: {},
            onCreate: () => {},
            onAdd: () => {},
            onClose: () => {}
        };
    }

    componentWillMount = () => {
        const isNewModalTestOn =
            typeof window !== 'undefined' && typeof window.__ABACUS__ !== 'undefined'
                ? AbacusClientUtils.evaluateExperiment(NEW_MODAL).value > 0
                : false;

        this.setState({
            isNewModalTestOn
        });
    };

    handleAddNewTripBoard = () => {
        this.setState({
            currentView: CREATE_BOARD,
            isEditing: true
        });

        edap.boardCreateClick(this.state.listingId);
    };

    handleAdd = (e, boardId) => {
        this.state.onAdd(this.state.addToBoard, boardId);
    };

    handleNameChange = (event) => {
        // todo set flag for first input and then handle
        this.setState({
            newBoardName: event.target.value,
            isEditing: true
        });
    };

    createIsDisabled = () => {
        const trimmendLength = this.state.newBoardName.trim().length;
        return trimmendLength < 1 || trimmendLength > MAX_TRIPBOARD_NAME_LENGTH;
    };

    handleClickCancel = () => {
        const {listingId, newBoardName} = this.state;
        edap.boardCreateCancel(listingId, newBoardName);

        this.setState({
            currentView: ADD_TO_BOARD,
            newBoardName: '',
            isEditing: false
        });
    };

    handleModalClose = () => {
        const {currentView, listingId, newBoardName} = this.state;
        const isCreateBoard = currentView === CREATE_BOARD;

        if (isCreateBoard) {
            edap.boardCreateDismiss(listingId, newBoardName);
        } else {
            edap.boardAddDismiss(listingId);
        }

        // Closing the modal and changing the view at the same time will
        // cause the view change to happen before the modal is closed.
        // In react-modal there is a setTimeout for 500ms while the modal fades out.
        // Set timeout for 501ms before changing the state of the open view to ensure the modal is closed.
        setTimeout(() => {
            this.setState(() => ({
                currentView: this.props.tripBoards && this.props.tripBoards.length > 0 ? ADD_TO_BOARD : CREATE_BOARD,
                newBoardName: '',
                isEditing: false
            }));
        }, 501);
    };

    handleClickCreate = (event) => {
        event.preventDefault();
        if (this.createIsDisabled()) {
            return;
        }
        const {createBoard, listingId, newBoardName} = this.state;
        this.state.onCreate(createBoard, newBoardName);

        edap.boardCreate(listingId, newBoardName);
    };

    close = () => {
        this.setState({isOpen: false});
    };

    open = (props) => {
        const noop = () => {};

        let {
            listingId,
            position,
            refButton,
            thumbnailUrl,
            tripBoards,
            onCreate,
            onAdd,
            onClose,
            createBoard,
            addToBoard,
            translations,
            rating,
            headline,
            reviewCount
        } = props;

        let currentView = tripBoards.length > 0 ? ADD_TO_BOARD : CREATE_BOARD;
        let isEditing = currentView === CREATE_BOARD;

        this.setState({
            isEditing,
            isOpen: true,
            currentView,
            newBoardName: '',

            // callbacks
            onCreate: onCreate || noop,
            onAdd: onAdd || noop,
            onClose: onClose || noop,

            // actions
            createBoard,
            addToBoard,

            // lingua translations
            translations,

            // button props
            listingId,
            position,
            refButton,
            thumbnailUrl,
            tripBoards,
            rating,
            headline,
            reviewCount
        });
    };

    onClose = () => {
        this.close();
        this.handleModalClose();
        this.state.onClose();
    };

    renderContent = () => {
        const {
            currentView,
            newBoardName,
            isNewModalTestOn,
            tripBoards,
            translations,
            rating,
            headline,
            reviewCount,
            thumbnailUrl
        } = this.state;

        let innerContent = !isNewModalTestOn ? (
            <AddToTripBoard tripBoards={tripBoards} translations={translations} onTripBoardClicked={this.handleAdd} />
        ) : (
            <TripBoardNewModal
                rating={rating}
                headline={headline}
                reviewCount={reviewCount}
                thumbnailUrl={thumbnailUrl}
            >
                <AddToTripBoardNewModal
                    tripBoards={tripBoards}
                    translations={translations}
                    onTripBoardClicked={this.handleAdd}
                    onCreateBoardClicked={this.handleAddNewTripBoard}
                />
            </TripBoardNewModal>
        );

        if (currentView === CREATE_BOARD) {
            innerContent = !isNewModalTestOn ? (
                <CreateTripBoard
                    handleClickCancel={this.handleClickCancel}
                    handleClickCreate={this.handleClickCreate}
                    newBoardName={newBoardName}
                    onNameChange={this.handleNameChange}
                    showCancel={tripBoards.length > 0}
                    translations={translations}
                    createIsDisabled={this.createIsDisabled()}
                />
            ) : (
                <TripBoardNewModal
                    rating={rating}
                    headline={headline}
                    reviewCount={reviewCount}
                    thumbnailUrl={thumbnailUrl}
                >
                    <CreateTripBoardNewModal
                        handleClickCancel={this.handleClickCancel}
                        handleClickCreate={this.handleClickCreate}
                        newBoardName={newBoardName}
                        onNameChange={this.handleNameChange}
                        showCancel={tripBoards.length > 0}
                        translations={translations}
                        createIsDisabled={this.createIsDisabled()}
                    />
                </TripBoardNewModal>
            );
        }
        return innerContent;
    };

    renderTitle = () => {
        const {currentView, isNewModalTestOn, translations, tripBoards} = this.state;
        const title =
            currentView === CREATE_BOARD
                ? translations['tripboards.modal.create.new.list.copy']
                : translations['tripboards.modal.add.to'];
        const createButtonText = translations['tripboards.modal.create.new.list'] || '';
        const emptyState = translations['tripboards.main.empty.state'];
        const heartMessages = emptyState && emptyState.split('{heart}');
        const createNewButton = (
            <div className="react-trip-board-button__create" onClick={this.handleAddNewTripBoard} role="button">
                <ButtonIcon className="react-trip-board-button__create-button" circle label={createButtonText}>
                    <svg className="react-trip-board-button__create-svg-plus" viewBox="0 0 50 50">
                        <path d="M50 22H28V0h-6v22H0v6h22v22h6V28h22" />
                    </svg>
                </ButtonIcon>
                <span className="react-trip-board-button__create-label">{createButtonText}</span>
            </div>
        );

        return (
            <div className="react-trip-board-button__title">
                <h2 className="react-trip-board-button__title-text">{title}</h2>
                {tripBoards.length <= 0 &&
                currentView === CREATE_BOARD &&
                isNewModalTestOn && (
                    <div className="react-trip-board-button__cta-text">
                        {heartMessages}{' '}
                        <SVGIcon
                            inlineFlex
                            markup={HEART_SELECTED__16}
                            className="react-trip-board-button__cta_heart"
                        />
                    </div>
                )}
                {currentView !== CREATE_BOARD && !isNewModalTestOn && createNewButton}
            </div>
        );
    };

    render() {
        const {isNewModalTestOn, isOpen, position, translations} = this.state;

        let {className, id} = this.props;

        if (isNewModalTestOn) {
            className = 'react-trip-board-button__new-modal';
            id = 'react-trip-board-button-new-modal';
        }

        return (
            <Modal
                id={id}
                className={className}
                title={this.renderTitle()}
                translations={translations}
                onClose={this.onClose}
                position={position}
                isOpen={isOpen}
            >
                {this.renderContent()}
            </Modal>
        );
    }
}

export default TripBoardModalContainer;
